
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap-tab-history');


window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if (document.querySelectorAll('.adomany-form').length > 0) {
	const app = new Vue({
		el: '.adomany-form',
		data() {
			return {
				amount: 2000,
				backingType: 'recurring'
			};
		},
		methods: {
			setAmount(amount) {
				this.amount = amount;
			}
		}
	});
}

jQuery.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
    }
});

jQuery(function () {
	jQuery('#private_email, #company_email').blur(function(event) {
		jQuery.ajax({
			url: "/email-available",
			method: "POST",
			data: { email : $(this).val() },
			dataType: "json"
		}).done(function( data ) {
			if (! data.available) {
				$('.alert-for-email').html('<div class="alert-warning">Ezzel az e-mail címmel már regisztráltak. Kérjük lépj be az oldalra a támogatáshoz.</div>');
				$('#submit-button').attr('disabled','disabled');
			}else{
				$('.alert-for-email').html('');
				$('#submit-button').removeAttr('disabled');
			}
		});
	});

	jQuery('.btn-tamogatasaim').click(function(event) {
		if (jQuery('.userName').length) {
			document.location = '/tamogatasaim';
		}else{
			$('.bd-nav-modal-lg').modal({
				show: true
			}); 
		}
	});

	$('[data-toggle="tooltip"]').tooltip();
});

